import { Component } from '@angular/core';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: 'day-trade-benefits',
    templateUrl: 'day-trade-benefits.component.html',
    styleUrls: ['./day-trade-benefits.component.scss']
})

export class DayTradeBenefits {
  public isNewBrand: boolean = environment.isNewBrand
}
